export const server = process.env.REACT_APP_API_SERVER
export const serverCFDI = process.env.REACT_APP_API_SERVER_CFDI
